<template>
  <div
    class="row"
    :class="[
      layout,
      collageLayout,
      { radius: backgroundColor || backgroundClass },
      backgroundColor ? '' : backgroundClass,
      row.type,
    ]"
    :style="backgroundColor ? `backgroundColor: ${backgroundColor}` : ''"
  >
    <div v-for="sort in getTypeRow.columns" :key="sort" class="row-item">
      <template
        v-if="getColumn(sort) && Array.isArray(getColumn(sort).content)"
      >
        <ContentGeneratorModulesText
          v-if="getColumn(sort).type === 'text'"
          :value="getColumn(sort)"
        />
        <ContentGeneratorModulesMedia
          v-if="getColumn(sort).type === 'photo'"
          :value="getColumn(sort)"
        />
        <ContentGeneratorModulesEmbedMedia
          v-if="getColumn(sort).type === 'embedMedia'"
          :value="getColumn(sort)"
        />
        <ContentGeneratorModulesProductBox
          v-if="['productBox'].includes(getColumn(sort).type)"
          :value="getColumn(sort)"
        />
        <CardBox
          v-if="['cardBox'].includes(getColumn(sort).type)"
          :value="getColumn(sort)"
        />
        <FeatureIconBox
          v-if="['featureIconBox'].includes(getColumn(sort).type)"
          :value="getColumn(sort)"
        />
        <FeaturePhotoBox
          v-if="['featurePhotoBox'].includes(getColumn(sort).type)"
          :value="getColumn(sort)"
        />
        <!-- TODO do usunięcia -->
        <!-- <ContentGeneratorModulesPhotoCollageOne
          v-if="getColumn(sort).type === 'photoCollageOne'"
          :value="getColumn(sort)"
        /> -->
        <!-- TODO do usunięcia -->
        <!-- <ContentGeneratorModulesPhotoCollageTwo
          v-if="getColumn(sort).type === 'photoCollageTwo'"
          :value="getColumn(sort)"
        /> -->
        <!-- TODO do usunięcia -->
        <!-- <ContentGeneratorModulesProductBoxCarousel
          v-if="getColumn(sort).type === 'productBoxCarousel'"
          :value="getColumn(sort)"
        /> -->
        <!-- TODO do usunięcia -->
        <!-- <ContentGeneratorModulesBoxTwoCarousel
          v-if="getColumn(sort).type === 'boxTwoCarousel'"
          :value="getColumn(sort)"
        /> -->
        <!-- TODO do usunięcia -->
        <!-- <ContentGeneratorModulesSummaryBox
          v-if="getColumn(sort).type === 'summaryBox'"
          :value="getColumn(sort)"
        /> -->

        <ContentGeneratorModulesTable v-if="getColumn(sort).type === 'table'" :value="getColumn(sort)" />
      </template>
    </div>
  </div>
</template>

<script>
import { contentFindOption, contentTypeRow } from '../../plugins/content'
import ContentGeneratorModulesText from './modules/Text.vue'
import ContentGeneratorModulesMedia from './modules/Media.vue'
import ContentGeneratorModulesEmbedMedia from './modules/EmbedMedia.vue'
import CardBox from './modules/CardBox.vue'
import FeatureIconBox from './modules/FeatureIconBox.vue'
import FeaturePhotoBox from './modules/FeaturePhotoBox.vue'
import ContentGeneratorModulesProductBox from './modules/ProductBox.vue'
import ContentGeneratorModulesTable from './modules/Table.vue'
export default {
  components: {
    ContentGeneratorModulesText,
    ContentGeneratorModulesMedia,
    ContentGeneratorModulesEmbedMedia,
    CardBox,
    FeatureIconBox,
    FeaturePhotoBox,
    ContentGeneratorModulesProductBox,
    ContentGeneratorModulesTable
  },
  props: {
    row: { type: Object, default: null }
  },
  computed: {
    backgroundColor () {
      return contentFindOption(this.row.options, 'backgroundColor').value || null
    },
    backgroundClass () {
      return contentFindOption(this.row.options, 'backgroundClass').value || null
    },
    getTypeRow () {
      return contentTypeRow.find(x => x.type === this.row?.type) || contentTypeRow[0]
    },
    layout () {
      return this.getTypeRow.type
    },
    collageLayout () {
      if (this.layout === 'four-modules') {
        return contentFindOption(this.row?.options, 'layout').value || 'layout-default'
      } else if (this.layout === 'three-modules') {
        return contentFindOption(this.row?.options, 'layout').value || 'one-row'
      }
      return null
    }
  },
  methods: {
    getColumn (sort) {
      if (this.row.modules) {
        return this.row.modules.find(x => x.options.find(y => y.key === 'sortModule' && y.value === sort)
        )
      }
      return null
    }

  }
}
</script>

<style lang="scss" scoped>
.row {
  margin: 60px 0;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  position: relative;

  .row-item {
    width: 100%;
  }

  &:not(:last-child) {
    margin: 60px 0;
  }

  &:deep(.text) {
    color: #0b0b0b;
  }

  &:deep(.feature-icon-box) {
    :deep(.text) {
      p {
        padding-left: 10px;
      }
    }
  }

  // > :deep(.text-container):first-child {
  //   padding-right: 12px;
  // }
  // > :deep(.text-container):last-child {
  //   padding-left: 24px;
  //   @include mobile {
  //     padding-left: 0;
  //   }
  // }
  > :deep(.text-container):only-child {
    padding: 0;
  }

  @include mobile {
    align-items: flex-start;
  }

  &.radius {
    border-radius: 20px;

    > :deep(.text-container):first-child {
      padding: 24px 12px 24px 48px;

      @include mobile {
        padding: 36px 24px 12px 34px;
      }
    }

    > :deep(.text-container):last-child {
      padding: 24px 48px 24px 24px;

      @include mobile {
        padding: 12px 24px 36px 34px;
      }
    }

    > :deep(.text-container):only-child {
      padding: 40px;
    }

    :deep(figure):first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      img {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      @include mobile {
        border-top-right-radius: 40px;

        img {
          border-top-right-radius: 40px;
        }
      }
    }

    :deep(figure):last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      img {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }

      @include mobile {
        border-bottom-left-radius: 40px;
        border-top-right-radius: 0;

        img {
          border-bottom-left-radius: 40px;
          border-top-right-radius: 0;
        }
      }
    }

    @include mobile {
      > :deep(.text):last-child {
        padding: 0 24px 24px;
      }
    }
  }

  &.fifty-fifty {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;

    :deep(.card-box) {
      max-width: 100%;
    }

    @include mobile {
      flex-direction: column;
      gap: 24px;
    }

    > :first-child {
      flex: 0 0 calc(50% - 12px);

      @include mobile {
        margin: 0;
      }
    }

    > :last-child {
      flex: 0 0 calc(50% - 12px);

      @include mobile {
        margin: 0;
      }
    }

    // padding - BoxThree no bg
    :deep(.feature-icon-box:not(.bcg)) {
      svg {
        top: 20px;
      }
    }

    :deep(.feature-icon-box) {
      p:first-child {
        padding-top: 0;
      }
    }
  }

  &.sixty-forty {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: stretch;

    // vertical-align: middle;
    :deep(.card-box) {
      max-width: 100%;
    }

    @include mobile {
      flex-direction: column;
    }

    > :first-child {
      flex: 0 0 calc(60% - 12px);

      @include mobile {
        margin: 0;
      }
    }

    > :last-child {
      flex: 0 0 calc(40% - 12px);

      & > :deep(.text) {
        // margin-left: 40px;
        @include mobile {
          margin-left: 0;
        }
      }
    }

    :deep(.feature-icon-box):last-child {
      p:first-child {
        padding-top: 0;
      }
    }
  }

  &.forty-sixty {
    display: flex;
    flex-direction: row;
    gap: 24px;

    :deep(.card-box) {
      max-width: 100%;
    }

    :deep(.feature-icon-box) {
      :deep(.text) {
        p {
          padding-left: 0;
        }
      }
    }

    @include mobile {
      flex-direction: column;
    }

    > :first-child {
      flex: 0 0 calc(40% - 12px);
    }

    > :last-child {
      flex: 0 0 calc(60% - 12px);
    }

    // padding - boxThree no bg
    :deep(.feature-icon-box:not(.bcg)) {
      svg {
        top: 20px;
      }
    }
  }

  &.one-third {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: flex-start;

    & > * {
      width: 33.33%;

      @include touch {
        width: 100%;
      }
    }

    @include mobile {
      flex-direction: column;

      :deep(.card-box) {
        max-width: 100%;
      }
    }

    :deep(.card-box) {
      align-self: stretch;
    }
  }

    &.four-modules {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-template-rows: repeat(3, 1/1);
    gap: 24px;
    @include touch{
      display: block;
      .row-item{
        margin-bottom: 16px;
      }
    }

  :deep(.card-box) {
    max-width: 100%;
  }

  :deep(.row-item) {
    border-radius: 20px;
  }

  :deep(.row-item):first-child {
    /* Duży po prawej: zajmuje 2 wiersze */
    grid-area: 1 / 2 / 3 / 3;
     aspect-ratio: 1/1;
     @include touch{
      aspect-ratio: unset;
     }
  }

  :deep(.row-item):nth-child(2) {
    /* Dół lewy */
    grid-area: 2 / 1 / 4 / 2;
    aspect-ratio: 1/1;
     @include touch{
      aspect-ratio: unset;
     }
  }

  :deep(.row-item):nth-child(3) {
    /* Dół prawy */
      grid-area: 3 / 2 / 4 / 3;
      aspect-ratio: 2/1;
       @include touch{
      aspect-ratio: unset;
     }

  }

  :deep(.row-item):last-child {
    /* Góra lewa */
    grid-area: 1 / 1 / 2 / 2;
    aspect-ratio: 2/1;
     @include touch{
      aspect-ratio: unset;
     }
  }

    @include mobile {
      flex-direction: column;
      gap: 24px;
    }

    & > * {
      flex: 0 0 calc(50% - 12px);
      @include mobile {
        margin: 0;
      }
    }

    // padding - BoxThree no bg
    :deep(.feature-icon-box:not(.bcg)) {
      svg {
        top: 20px;
      }
    }
    :deep(.feature-icon-box) {
      max-width: 100%;
      width: 100%;
      height: 100%;
      p:first-child {
        padding-top: 0;
      }
    }
  }

  &.layout-reverse {
    :deep(.row-item):first-child {
      /* Duży po LEWEJ: zajmuje 2 wiersze */
      grid-area: 1 / 1 / 3 / 2;
    }

    :deep(.row-item):nth-child(2) {
      /* Dół PRAWY */
      grid-area: 2 / 2 / 4 / 3;
      aspect-ratio: 1/1;
       @include touch{
      aspect-ratio: unset;
     }
    }

    :deep(.row-item):nth-child(3) {
      /* Dół LEWY */
      grid-area: 3 / 1 / 4 / 2;
      aspect-ratio: 2/1;
       @include touch{
      aspect-ratio: unset;
     }
    }

    :deep(.row-item):last-child {
      /* Góra PRAWa */
      grid-area: 1 / 2 / 2 / 3;
      aspect-ratio: 2/1;
       @include touch{
      aspect-ratio: unset;
     }
    }
  }

    /* Base grid for three-modules */
  &.three-modules {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-auto-rows: auto;
    gap: 20px;

    :deep(.row-item) {
      border-radius: 20px;
       overflow: hidden;

      .product-box {
        height: 100%;
      }
      .photo-wrapper{
        height: 100%;
           @include touch{
          height: 100%;
          }
        figure{
         @include touch{
          height: 100%;
          }
        }

      }
      .feature-icon-box{
        height: 100%;
        .photo-wrapper{
          height: 40px !important;
          width: 40px !important;
        }
      }

    }

    @include touch{
      display: block;
      .row-item{
        margin-bottom: 16px;
      }
    }
  }

  &.three-modules.one-row {
    :deep(.row-item):nth-child(1) {
      grid-column: 1 / 4; /* left side */
      grid-row: 1 / span 2; /* tall */
      aspect-ratio: 1/1.04;
      @include touch{
      aspect-ratio: unset;
      }
      >.photo-wrapper {
        height: 100%;
        aspect-ratio: unset !important;
          @include touch{
          height: 100%;
          }

        .photo-wrapper {
          height: 100%;
          >div{
            height: 100%;
          }
          .video{
            height: 100%;
          }
          figure{
            @include touch{
             height: 100% !important;
          }
          }
        }

        figure {
          height: 100%;
          aspect-ratio: unset !important;
          @include touch{
          height: 100% !important;
          }
        }
      }
      :deep(.feature-icon-box){
        .photo-wrapper{
          height: 40px !important;
          width: 40px !important;
        }
      }

      .product-box {
        aspect-ratio: unset;
      }

    }
    :deep(.row-item):nth-child(2) {
      grid-column: 4 / 7; /* right – top */
      grid-row: 1;
      aspect-ratio: 2/1;
      @include touch {
        aspect-ratio: unset;
      }
    }
    :deep(.row-item):nth-child(3) {
      grid-column: 4 / 7; /* right – bottom */
      grid-row: 2;
      aspect-ratio: 2/1;
      @include touch {
        aspect-ratio: unset;
      }
    }
  }

  &.three-modules.one-row-reversed {
    :deep(.row-item):nth-child(1) {
      grid-column: 4 / 7; /* right side */
      grid-row: 1 / span 2;
      aspect-ratio: 1/1.04;
      @include mobile {
        aspect-ratio: 1/1;
      }
            >.photo-wrapper {
        height: 100% !important;
        aspect-ratio: unset !important;
          @include touch{
          height: 100%;
          }

        .photo-wrapper {
          height: 100%;
          >div{
            height: 100%;
          }
          .video{
            height: 100%;
          }
          figure{
            @include touch{
             height: 100% !important;
          }
          }
        }

        figure {
          height: 100%;
          aspect-ratio: unset !important;
          @include touch{
          height: 100% !important;
          }
        }
      }
    }
    :deep(.row-item):nth-child(2) {
      grid-column: 1 / 4; /* left – top */
      grid-row: 1;
      aspect-ratio: 2/1;
      @include mobile{
        aspect-ratio: unset;
      }
    }
    :deep(.row-item):nth-child(3) {
      grid-column: 1 / 4; /* left – bottom */
      grid-row: 2;
      aspect-ratio: 2/1;
      @include mobile{
        aspect-ratio: unset;
      }
    }
  }

  &.three-modules.two-row {
    :deep(.row-item):nth-child(1) {
      grid-column: 1 / -1; /* full width */
      aspect-ratio: 2/1;
      @include mobile {
        aspect-ratio: 1/1;
      }
    }
    :deep(.row-item):nth-child(2) {
      grid-column: 1 / 4; /* left half */
      grid-row: 2;
      aspect-ratio: 2/1;
      @include touch {
        aspect-ratio: unset;
      }
    }
    :deep(.row-item):nth-child(3) {
      grid-column: 4 / 7; /* right half */
      grid-row: 2;
      aspect-ratio: 2/1;
      @include touch {
        aspect-ratio: unset;
      }
    }
  }

  &.three-modules.two-row-reversed {
    :deep(.row-item):nth-child(1) {
      grid-column: 1 / -1; /* full width */
      grid-row: 2;
      aspect-ratio: 2/1;
      @include mobile {
        aspect-ratio: 1/1;
      }
    }
    :deep(.row-item):nth-child(2) {
      grid-column: 4 / 7; /* right half */
      grid-row: 1;
      aspect-ratio: 2/1;
      @include touch {
        aspect-ratio: unset;
      }
    }
    :deep(.row-item):nth-child(3) {
      grid-column: 1 / 4; /* left half */
      grid-row: 1;
      aspect-ratio: 2/1;
      @include touch {
        aspect-ratio: unset;
      }
    }
  }
}
</style>
